import React from 'react';

import './ManageClient.css';
import Modal from '../../../components/UI/Modal/Modal';
import FormGrid from '../../../components/UI/FormGrid/FormGrid';
import Textbox from '../../../components/UI/Textbox/Textbox';
import Textarea from '../../../components/UI/Textarea/Textarea';
import Button from '../../UI/Button/Button';


/**
* @desc Add and update client(Modal)
* @version 0.1.0
* @author Jamshith
*/


const ManageClient = (props) => {
  return(
    <Modal show={props.showAddCompanymodal || props.showUpdateCompanyModal} className="add-company-modal" backdropClassName="manage-client-backdrop">
        <div className="add-company-modal-header">{props.showAddCompanymodal?"Add Client":"Update Client"}</div>
        <div className="add-company-modal-sub-header">Company Details</div>
        <FormGrid grid="auto auto">
          <Textbox 
            id="companyName" 
            className={(props.errorPosition.includes("companyName")) ?"invalid-input":""}
            label="Company Name:" 
            placeholder="Enter Company Name" 
            value={props.clientDetails.companyName} 
            onChange={(event) => props.handleClientDetailsChange(event)}
            >
            <p className="error-message">{(props.errorPosition.includes("companyName")) ? "Please enter Company Name" : null}</p>          
          </Textbox>
          <Textbox 
            id="companyBHId" 
            className={(props.errorPosition.includes("companyBHId")||props.errorPosition.includes("CompanyExists")||props.errorPosition.includes("invalidCompanyBHId")) ? "invalid-input" :"" }
            label="Company BH ID:" 
            placeholder="Enter Company BH ID" 
            value={props.clientDetails.companyBHId} 
            onChange={(event) => props.handleClientDetailsChange(event)}
            onKeyPress={(event)=>props.handleKeyPressChange(event)}
            onPaste ={(event)=>props.handlePasteChange(event)}
            > 
            <p className="error-message">
            {(props.errorPosition.includes("companyBHId")) ? "Please enter Company BH ID" 
            : (props.errorPosition.includes("CompanyExists"))?"Company already exists":
            (props.errorPosition.includes("invalidCompanyBHId"))?"Please enter valid Company BH ID":null}</p>
          </Textbox>
        </FormGrid>
        <FormGrid>
        <Textarea 
          id="companyAddress" 
          label="Company Address:" 
          placeholder="Enter Contact Company Address" 
          onChange={(event) => props.handleClientDetailsChange(event)}
          inValid={(props.errorPosition.includes("companyAddress")) ?"Invalid":""}          
          errorMsg = {(props.errorPosition.includes("companyAddress")) ?"Please enter company Address":""} 
          value={props.clientDetails.companyAddress}
        >
        </Textarea>        
        </FormGrid>
          <div className="add-company-modal-sub-header">Primary Contact Details</div>
          <FormGrid grid="auto auto" className="primary-contact">
            <Textbox 
            id="contactName" 
            className={(props.errorPosition.includes("contactName")) ?"invalid-input":""}
            label="Full Name:" 
            placeholder="Enter Contact Full Name" 
            value={props.clientDetails.contactName} 
            onChange={(event) => props.handleClientDetailsChange(event)}
            >
            <p className="error-message">{(props.errorPosition.includes("contactName")) ? "Please enter Full Name" : null}</p>          
            </Textbox>
            <Textbox 
              id="contactEmail" 
              className={(props.errorPosition.includes("contactEmailEmpty")) ? "invalid-input" : 
                (props.errorPosition.includes("contactEmailFormat")) ?"invalid-input" : ""}
              label=" Email Address:" 
              placeholder="Enter Contact Email Address" 
              //disabled={props.clientDetails.userId?true:false}
              value={props.clientDetails.contactEmail} 
              onChange={(event) => props.handleClientDetailsChange(event)}
              > 
              <p className="error-message">{(props.errorPosition.includes("contactEmailEmpty")) ? "Please enter Email" :
              props.errorPosition.includes("contactEmailFormat") ? "Please enter a valid Email" :
              props.errorPosition.includes("UserExists")?"User already exists":""}</p>
            </Textbox>
            <Textbox 
              id="bullhornId" 
              className={props.errorPosition.includes("bullhornId")||props.errorPosition.includes("BullhornIdExists")||props.errorPosition.includes("invalidBullhornId")? "invalid-input" : ""}
              label="Bullhorn ID:" 
              placeholder="Enter  Contact Bullhorn ID" 
              value={props.clientDetails.bullhornId} 
              onChange={(event) => props.handleClientDetailsChange(event)}
              onKeyPress={props.handleKeyPressChange}
              onPaste ={(event)=>props.handlePasteChange(event)}
              > 
              <p className="error-message">
                {(props.errorPosition.includes("bullhornId")) ? "Please enter Bullhorn Id" :
                (props.errorPosition.includes("BullhornIdExists")) ? "Bullhorn ID exists": 
                (props.errorPosition.includes("invalidBullhornId")) ? "Please enter valid Bullhorn Id":null}
              </p>
            </Textbox>
            <Textbox 
              id="telephoneNo" 
              className={props.errorPosition.includes("telephoneNo")||props.errorPosition.includes("invalidTelephoneNo")? "invalid-input" : ""}
              label="Telephone Number:" 
              placeholder="Enter Contact Telephone Number" 
              value={props.clientDetails.telephoneNo} 
              onChange={(event) => props.handleClientDetailsChange(event)}
              onKeyPress={props.handleKeyPressChange}
              onPaste ={(event)=>props.handlePasteChange(event)}
              > 
              <p className="error-message">{(props.errorPosition.includes("telephoneNo")) ? "Please enter Telephone Number" : 
              (props.errorPosition.includes("invalidTelephoneNo"))?"Please enter valid Number":null}</p>
            </Textbox>
          </FormGrid>
      <div className="add-company-modal-footer">
        <Button uistyle="lesser" onClick={props.handleCancelAddCompany}>Cancel</Button>
        <Button  onClick={props.submitClientDetails} disabled={props.disableAddbutton}>{props.showAddCompanymodal?"Add":"Save"}</Button>
      </div>
    </Modal>
  );
}

export default ManageClient;


// WEBPACK FOOTER //
// ./src/components/Admin/ManageClient/ManageClient.js